export default __webpack_public_path__ + "static/O0020-8a6d88a2c44dfca9abc6f3fde28e40c2.png";